import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronRight, FolderOpen, Settings2 } from "lucide-react";
import {
  buildProjectTreeTitleLink,
  buildProjectTreeTitleSegments,
} from "./projectOptionalTitleUtils.js";
import { normalizeRoadmapLevels } from "./ProjectRoadmapPanel.jsx";
import "css/projectWorkspace.css";

const LEVEL_LABELS = {
  buildingName: "건물",
  floor: "층",
  location: "위치",
  facilityType: "설비 구분",
  facilityName: "설비명",
  partName: "부품명",
};
const LEVELS = normalizeRoadmapLevels();

export default function ProjectOptionalTitle({
  project_id,
  project_name,
  title = "파일 목록",
  onOpenMetrics,
}) {
  const location = useLocation();
  const { t } = useTranslation();
  const searchParams = new URLSearchParams(location.search);
  const segments = buildProjectTreeTitleSegments(
    searchParams,
    t("projectDetail.roadmap.unassigned", { defaultValue: "미지정" }),
  );
  const currentNode = segments[segments.length - 1];
  const CurrentIcon =
    LEVELS.find((level) => level.selectionKey === currentNode?.key)?.icon ||
    FolderOpen;
  const isReport = location.pathname.endsWith("/report");
  const rootPath = `/project/${project_id}${isReport ? "/report" : ""}`;
  const keyword = searchParams.get("searchKeyword");
  const hasDetails = ["fileType", "facilityType", "fusionResult"].some((key) =>
    searchParams.get(key),
  );
  const legacy =
    !segments.length &&
    [searchParams.get("index"), searchParams.get("value")]
      .filter(Boolean)
      .join(" · ");
  return (
    <div className="projectContextTitle">
      <div className="projectContextTitle__heading">
        <CurrentIcon size={20} aria-hidden="true" />
        <h2>{currentNode?.label || project_name || "프로젝트"}</h2>
      </div>
      {Boolean(segments.length || legacy || keyword || hasDetails || onOpenMetrics) && <nav className="projectContextTitle__path" aria-label="현재 조회 범위">
        {segments.length > 0 && <Link to={rootPath}>프로젝트 전체</Link>}
        {segments.map((segment, index) => {
          const target = buildProjectTreeTitleLink(project_id, segments, index);
          return (
            <span className="projectContextTitle__segment" key={segment.key}>
              <ChevronRight size={13} aria-hidden="true" />
              <Link
                to={
                  isReport
                    ? target.replace(`/project/${project_id}?`, `${rootPath}?`)
                    : target
                }
                aria-current={
                  index === segments.length - 1 ? "location" : undefined
                }
              >
                <small>{LEVEL_LABELS[segment.key]}</small> {segment.label}
              </Link>
            </span>
          );
        })}
        {legacy && (
          <span className="projectContextTitle__filter">분류: {legacy}</span>
        )}
        {keyword && (
          <span className="projectContextTitle__filter">검색: {keyword}</span>
        )}
        {hasDetails && (
          <span className="projectContextTitle__filter">상세 조건 적용</span>
        )}
        {onOpenMetrics && !["facilityName", "partName"].includes(currentNode?.key) && <button type="button" className="projectContextTitle__metrics" aria-label="지표 설정" onClick={onOpenMetrics}><Settings2 size={16} aria-hidden="true" />지표 설정</button>}
      </nav>}
    </div>
  );
}
